module.exports = __webpack_public_path__ + "static/media/Baggage Cropped.eaf0f74e.jpg";